import { Paper, Typography, Button, TextField, FormControl, Select, MenuItem, InputLabel, FormGroup,  LinearProgress} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TBOBook from "./tbobook";
import { fetchTokenData, updateTokenData, fetchToken, fetchflights, fetchfarerule, fetchfarequote, fetchssr, refreshTCToken, searchTCflight } from "../api/customerapi";
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { DateCalc2, airportlist, getSumByKey2, getairlinecode, airlinelist, gettimediff} from "./date.js";
import DateCalc from "./date.js";
import Stack from '@mui/material/Stack';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    formgroup: {
        justifyContent: "center",
      },
     red: {
        color: "red",
        marginLeft: theme.spacing(3),
      },
      blue: {
        color: "blue",
        marginLeft: theme.spacing(3),
      },
      purple: {
        color: "purple",
        marginLeft: theme.spacing(3),
      },
      brown: {
        color: "brown",
        marginLeft: theme.spacing(3),
      },
      orange: {
        color: "orange",
        marginLeft: theme.spacing(3),
      },
      black: {
        color: "black",
        marginLeft: theme.spacing(3),
      },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
      textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "left",
      },
      
  }));

const TBOSearch=() => {
    const airlinelist2=airlinelist.sort()
    const classes = useStyles();
    const [searchData, setsearchData]=useState({
        number_adults:2,
        number_child:0,
        number_infant:0,
        type:"Return",
        stops:"Any",
    })
    const [value, setValue] = useState(0);
    const [filterData, setfilterData] = useState({});
    const [control, setcontrol] = useState(false);
    const [token, settoken] = useState("");
    const [showbook, setshowbook] = useState(false);
    const [tcresultpass, settcresultpass] = useState([]);
    const [inbound, setinbound] = useState(false);
    const [inboundindex, setinboundindex] = useState(null);
    const [status, setstatus] = useState("Normal");
    const [resultpass, setresultpass] = useState([]);
    const [searchResponse, setsearchResponse] = useState("");
    const [saveresults, setsaveresults] = useState("");
    const [filterData2, setfilterData2] = useState({});
    const [airportdata, setairportdata] = useState([{ id: uuidv4(),  
      cabin_class:"Economy",
    departure_time:"All Day",
    arrival_time:"All Day",
  source:"", dest:""}, 
    { id: uuidv4(),  cabin_class:"Economy",
    departure_time:"All Day",
    arrival_time:"All Day", source:"", dest:""}]);
    const airportlist2=airportlist.sort((a, b) => (a.city > b.city) ? 1: -1);
    var fupsomeDate = new Date();

  fupsomeDate.setDate(fupsomeDate.getDate());
  const fupy = fupsomeDate.getFullYear();
  const fupm =
    fupsomeDate.getMonth() + 1 < 10
      ? "0" + (fupsomeDate.getMonth() + 1)
      : fupsomeDate.getMonth() + 1;
  const fupdt =
    fupsomeDate.getDate() < 10
      ? "0" + fupsomeDate.getDate()
      : fupsomeDate.getDate();
  const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;

    useEffect(() => {
       getTCToken()
    
      }, []);

      const TCFlightSearch =async (e) => {
        console.log(searchData)
        if(searchData.number_adults+searchData.number_child+searchData.number_infant>9){
          alert("Total passengers cannot be more than 9")
        }else{
        setstatus("searching");
        //var segment=[]
        console.log(airportdata);
        const s=airportlist.filter(a=>a.city==airportdata[0].source)
        const d=airportlist.filter(a=>a.city==airportdata[0].dest)
       
      
      const finalsearchData={
        data:{
          adultCount:searchData.number_adults,
          childCount :searchData.number_child,
          infantCount:searchData.number_infant,
          directFlight:searchData.stops==0?true:false,
          flightCabinClass: "1",
          journeyType:searchData.type=="One-way" ? 1: searchData.type=="Return"?2: searchData.type=="Multi-stop"?3: searchData.type=="Special Return"?5:searchData.type=="Advanced Search"?4:0,
          origin:s.length>0?s[0].airport:"",
          destination:d.length>0?d[0].airport:"",
          // "preferredDepartureTime": "2024-11-01T00:00:00",
          // "preferredReturnDepartureTime": "2024-11-08T00:00:00",
          preferredDepartureTime: airportdata.length>0?new Date(DateCalc2(airportdata[0].date,0)):new Date(),
          preferredReturnDepartureTime: airportdata.length>1?new Date(DateCalc2(airportdata[1].date,0)):new Date(),
        },
        token:token
      }
      
        console.log(finalsearchData)
        const sfResponse= await searchTCflight(finalsearchData);
        
        if(sfResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          
            console.log(sfResponse.data.response)
            setsaveresults(sfResponse.data)
            setsearchResponse(sfResponse.data.response)
            setstatus("completed")
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/home");
        }
      }
      }

      const getToken=async()=>{
        const data= await fetchTokenData();
        //console.log(data.data)
        settoken(data.data[0].token)
        const newDate=DateCalc(0)
        const saveddate=DateCalc2(data.data[0].date, 0)
        //const saveddate=2
        //console.log(data.data[0])
        if(newDate!==saveddate){
            console.log("Fetching token")
            const newtokendata={
              "ClientId": "tboprod",
              "UserName": "DELJ300",
              "Password": "@dminInd$987#", 
              //"Password": "Operations@1234", 
            }
            console.log(newtokendata)
            const data2 = await fetchToken(newtokendata);
            
            console.log(data2.data)
            settoken(data2.data.TokenId)
            const newtokendata2={
              token:data2.data.TokenId,
              date:new Date()
            }
            //console.log(newtokendata2)
            const updatetokenResponse= await updateTokenData(data.data[0]._id, newtokendata2);
            
            if(updatetokenResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                console.log("Token Data Updated")
            }
            else{
                alert("Unable to refresh currency data");
                
            }
        }else{
            console.log("New token will be fetched after 24 hours")
        }
        
       }

      const addsp = () => {
        //console.log(spdata)
    
        setairportdata(
          airportdata.length == 0 ? [{ id: uuidv4(), cabin_class:"Economy",
          departure_time:"All Day",
          arrival_time:"All Day"}] : [...airportdata, { id: uuidv4(), cabin_class:"Economy",
          departure_time:"All Day",
          arrival_time:"All Day"}]
        );
      };
    
      const removesp = () => {
        //console.log(spdata)
        setairportdata([...airportdata].slice(0, airportdata.length - 1));
      };

      const sourcechange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        //console.log(newdata)
        const newitem = { ...newdata, source: e.target.value };
        
        if(searchData.type=="Return" || searchData.type=="Special Return"){
          if(airportdata[tid+1]){
            const newitem2 = { ...airportdata[tid+1], dest: e.target.value };
            setairportdata([newitem, newitem2])
            //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
          }else{
            setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
          }  
        }else{
          setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        }
        setstatus("ABC")
       
      };
    
      const destchange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        const newitem = { ...newdata, dest: e.target.value };

        if(searchData.type=="Return" || searchData.type=="Special Return"){
          if(airportdata[tid+1]){
            const newitem2 = { ...airportdata[tid+1], source: e.target.value };
            setairportdata([newitem, newitem2])
            //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
          }else{
            setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
          }  
        }else{
          setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        }
        //console.log(newitem)
        //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const datechange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        const newitem = { ...newdata, date: e.target.value };
        //console.log(newitem)
        setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const classchange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        const newitem = { ...newdata, cabin_class: e.target.value };
        //console.log(newitem)
        setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
      const departurechange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        const newitem = { ...newdata, departure_time: e.target.value };
        console.log(newitem)
        setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
      const arrivalchange = (e, tid, id) => {
        //console.log(tid, id)
        const newdata = airportdata[tid];
        const newitem = { ...newdata, arrival_time: e.target.value };
        console.log(newitem)
        setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const controlleg=(value)=>{
        setsearchData({...searchData, type:value})
        
        if(value=="One-way"){
            setcontrol(false)
            setairportdata([{ id: uuidv4(),cabin_class:"Economy",
            departure_time:"All Day",
            arrival_time:"All Day"},])
        }else if(value=="Return" || value=="Special Return"){
            setcontrol(false)
            setairportdata([{ id: uuidv4(), cabin_class:"Economy",
            departure_time:"All Day",
            arrival_time:"All Day", source:"", dest:""}, 
            { id: uuidv4(), cabin_class:"Economy",
            departure_time:"All Day",
            arrival_time:"All Day", source:"", dest:""}])
        }else{
            setcontrol(true)
        }
      }

      const getdate=(date, time) =>{
        if(time=="All Day"){
          return date+"T00:00:00"
        }else if(time=="Morning"){
          return date+"T08:00:00"
        }else if(time=="Afternoon"){
          return date+"T14:00:00"
        }else if(time=="Evening"){
          return date+"T19:00:00"
        }else if(time=="Night"){
          return date+"T01:00:00"
        }
      }

      const getclass=(value) =>{
        if(value==2){
          return "Economy"
        }else if(value==3){
          return "Premium Economy"
        }else if (value==4){
          return "Business"
        }else if (value==5){
          return "Premium Business"
        }else if (value==6){
          return "First"
        }
      }

      const getprice=(fare)=>{
        var x=
          ("BaseFare" in fare?fare.BaseFare:0)+
          ("Tax" in fare?fare.Tax:0)+
          ("OtherCharges" in fare?fare.OtherCharges:0)+
          ("ServiceFee" in fare?fare.ServiceFee:0)+
          ("AirlineTransFee" in fare?fare.AirlineTransFee:0)-
          ("PLBEarned" in fare?fare.PLBEarned:0)-
          ("CommissionEarned" in fare?fare.CommissionEarned:0)-
          ("IncentiveEarned" in fare?fare.IncentiveEarned:0)+
          ("TdsOnPLB" in fare?fare.TdsOnPLB:0)+
          ("TdsOnCommission" in fare?fare.TdsOnCommission:0)+
          ("TdsOnIncentive" in fare?fare.TdsOnIncentive:0)+
          ("GST" in fare?fare.GST:0)
        return Math.round(x)
      }

      const getduration=(segment)=>{
        if(searchData.type=="Multi-stop"){
          return ""
        }else{
        var x=getSumByKey2(segment, "Duration")
        if(segment.length>1){
          for(let i=1;i<segment.length;i++){
            const temp=Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
            x+=temp
          }
        }
       
        return " || Total Duration: "+Math.floor(x/60)+"hrs "+Math.floor(x%60)+"mins"
      }
      }

      const getduration2=(segment)=>{
        if(searchData.type=="Multi-stop"){
          return ""
        }else{
        var x=getSumByKey2(segment, "Duration")
        if(segment.length>1){
          for(let i=1;i<segment.length;i++){
            const temp=Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
            x+=temp
          }
        }
       
        return x
      }
      }

      const getstopover=(segment)=>{
        var x=0
       if(segment.length<2){
        return x
       }else{
        for(let i=1;i<segment.length;i++){
          // if("GroundTime" in segment[i] && segment[i].GroundTime>0){
          //   x=x+segment[i].GroundTime
          // }else{
            if(segment[i-1]){
              x=x+Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
            }
            
          
          }
        return x
       }
        
      }

      const handleChange = (event, newValue) => {
        setValue(newValue);
        
      };

      const checkairline = (segments, value) => {
        let x=0
        for(let i=0;i<segments.length;i++){
          for(let j=0;j<segments[i].length;j++){
            if(segments[i][j].Airline.AirlineCode==getairlinecode(value)){
              x= 1
              
            }
          }
        }
        return x
      }

      const checkbaggage = (segments, value) => {
        let x=""
        for(let i=0;i<segments.length;i++){
          for(let j=0;j<segments[i].length;j++){
            if(segments[i][j].Baggage=="15 kgs" || segments[i][j].Baggage=="20 KG" || segments[i][j].Baggage=="1 Piece(s)"){
              x= "1"
              break;
            }
            if(segments[i][j].Baggage=="30 KG" || segments[i][j].Baggage=="40 KG"){
              x= "2"
              break;
            }
            if(segments[i][j].Baggage=="45 kgs" || segments[i][j].Baggage=="60 KG"){
              x= "3"
              break;
            }
          }
        }
        return x
      }

      const filterresults=() => {
        var newData=[]
        var ftype=0
        if(searchData.type=="One-Way"){
         ftype=1
        }else if(searchData.type=="Return"){
         if(searchResponse.Results.length>1){
           ftype=3
         }else{
           ftype=2
         }
        }else if(searchData.type=="Multi-stop"){
         ftype=4
        }else if(searchData.type=="Special Return"){
         ftype=5
        }else{
         ftype=6
        }
        //console.log(ftype)
       
         if(filterData.airline) {
            //console.log(getairlinecode(filterData.airline))
           newData[0]=saveresults.Response.Results[0].filter(r=>checkairline(r.Segments, filterData.airline))
           if(saveresults.Response.Results.length>1){
             newData[1]=saveresults.Response.Results[1].filter(r=>checkairline(r.Segments, filterData.airline))
           }
         }else{
           newData=[...saveresults.Response.Results]
         }
         if(filterData.departure && filterData.departure !=="All-Day") {
           if(filterData.departure =="00-08"){
             // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()<8)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()<8)
           }
         }
         if(filterData.departure =="08-14"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<14)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<14)
         }
       }
       if(filterData.departure =="14-19"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
       }
       }
       if(filterData.departure =="19-23"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
       }
       }
         }
         if(ftype==2){
           if(filterData.arrival && filterData.arrival !=="All-Day") {
             if(filterData.arrival =="00-08"){
               // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
             newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<8)
           }
           if(filterData.arrival =="08-14"){
             // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<14)
         }
         if(filterData.arrival =="14-19"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<19)
         }
         if(filterData.arrival =="19-23"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<24)
         
         }
           }
         }else{
           if(filterData.arrival && filterData.arrival !=="All-Day") {
             if(filterData.arrival =="00-08"){
               // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
             newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
             if(saveresults.Response.Results.length>1){
               newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
             }
           }
           if(filterData.arrival =="08-14"){
             // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)
           }
         }
         if(filterData.arrival =="14-19"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)
         }
         }
         if(filterData.arrival =="19-23"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)
         if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)
         }
         }
           }
         }
         
         
         if(filterData.duration) {
           if(filterData.duration =="0-4 hrs"){
             //console.log(getduration2(newData[0][0].Segments[0]))
           newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])<240)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])<240)
           }
         }
         if(filterData.duration =="4-8 hrs"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=240 && getduration2(r.Segments[0])<480)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=240 && getduration2(r.Segments[0])<480)
         }
       }
       if(filterData.duration =="8-12 hrs"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=480 && getduration2(r.Segments[0])<720)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=480 && getduration2(r.Segments[0])<720)
       }
       }
       if(filterData.duration =="12-16 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=720 && getduration2(r.Segments[0])<960)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=720 && getduration2(r.Segments[0])<960)
       }
       }
       if(filterData.duration =="16-20 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=960 && getduration2(r.Segments[0])<1200)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=960 && getduration2(r.Segments[0])<1200)
       }
       }
       if(filterData.duration =="20-24 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=1200 && getduration2(r.Segments[0])<1440)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=1200 && getduration2(r.Segments[0])<1440)
       }
       }
       if(filterData.duration =="24+ hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=1440)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=1440)
       }
       }
         }
         if(filterData.stops) {
           if(filterData.stops =="0"){
             //console.log(getduration2(newData[0][0].Segments[0]))
           newData[0]=newData[0].filter(r=>r.Segments[0].length==1)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>r.Segments[0].length==1)
           }
         }
         if(filterData.stops =="1"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>r.Segments[0].length==2)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>r.Segments[0].length==2)
         }
       }
       if(filterData.stops =="2"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments[0].length==3)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>r.Segments[0].length==3)
       }
       }
       if(filterData.stops =="3"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments[0].length==4)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>r.Segments[0].length==4)
       }
       }
         }
         if(filterData.baggage) {
           if(filterData.baggage =="0"){
             console.log(checkbaggage(newData[0][0].Segments,filterData.baggage))
           newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
           }
         }
         if(filterData.baggage =="1"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
         }
       }
       if(filterData.baggage =="2"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
       }
       }
       if(filterData.baggage =="3"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
       }
       }
         }
         if(filterData.multi) {
           if(filterData.multi =="Yes"){
             //console.log(getduration2(newData[0][0].Segments[0]))
           newData[0]=newData[0].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName || r.Segments[0][0].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName || r.Segments[0][1].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName  )))
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName || r.Segments[0][0].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName || r.Segments[0][1].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName  )))
           }
         }
         if(filterData.multi =="No"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
           newData[0]=newData[0].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName && r.Segments[0][0].Airline.AirlineName == r.Segments[0][2].Airline.AirlineName )))
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName && r.Segments[0][0].Airline.AirlineName == r.Segments[0][2].Airline.AirlineName )))
         }
       }
       if(filterData.stops =="2"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
       }
       }
       if(filterData.stops =="3"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
       }
       }
         }
         if(filterData.stopover) {
           if(filterData.stopover =="0-4 hrs"){
             console.log(getstopover(newData[0][0].Segments[0]))
           newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])<240)
           if(saveresults.Response.Results.length>1){
             newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])<240)
           }
         }
         if(filterData.stopover =="4-8 hrs"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=240 && getstopover(r.Segments[0])<480)
         if(saveresults.Response.Results.length>1){
           newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=240 && getstopover(r.Segments[0])<480)
         }
       }
       if(filterData.stopover =="8-12 hrs"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=480 && getstopover(r.Segments[0])<720)
       if(saveresults.Response.Results.length>1){
         newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=480 && getstopover(r.Segments[0])<720)
       }
       }
       if(filterData.stopover =="12-16 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=720 && getstopover(r.Segments[0])<960)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=720 && getstopover(r.Segments[0])<960)
       }
       }
       if(filterData.stopover =="16-20 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=960 && getstopover(r.Segments[0])<1200)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=960 && getstopover(r.Segments[0])<1200)
       }
       }
       if(filterData.stopover =="20-24 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=1200 && getstopover(r.Segments[0])<1440)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=1200 && getstopover(r.Segments[0])<1440)
       }
       }
       if(filterData.stopover =="24+ hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=1440)
       if(saveresults.Response.Results.length>1){
       newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=1440)
       }
       }
       }
       //----------------------------------------return flight search------------------------------
       if(ftype=2){
        
        if(filterData2.departure && filterData2.departure !=="All-Day") {
          if(filterData2.departure =="00-08"){
            // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
          newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<8)
          
        }
        if(filterData2.departure =="08-14"){
          // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
        newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<14)
        
       }
       if(filterData2.departure =="14-19"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<19)
       
       }
       if(filterData2.departure =="19-23"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<24)
       }
        }
       
        if(filterData2.arrival && filterData2.arrival !=="All-Day") {
         if(filterData2.arrival =="00-08"){
           // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
         newData[0]=newData[0].filter(r=>new Date(r.Segments.length>1 && r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
       }
       if(filterData2.arrival =="08-14"){
         // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)
       
       }
       if(filterData2.arrival =="14-19"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)
       
       }
       if(filterData2.arrival =="19-23"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)
       
       }
       }
       
        if(filterData2.duration) {
          if(filterData2.duration =="0-4 hrs"){
            //console.log(getduration2(newData[0][0].Segments[0]))
          newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])<240)
          
        }
        if(filterData2.duration =="4-8 hrs"){
          // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
        newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=240 && getduration2(r.Segments[1])<480)
        
       }
       if(filterData2.duration =="8-12 hrs"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=480 && getduration2(r.Segments[1])<720)
       
       }
       if(filterData2.duration =="12-16 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=720 && getduration2(r.Segments[1])<960)
       
       }
       if(filterData2.duration =="16-20 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=960 && getduration2(r.Segments[1])<1200)
       
       }
       if(filterData2.duration =="20-24 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=1200 && getduration2(r.Segments[1])<1440)
       
       }
       if(filterData2.duration =="24+ hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=1440)
       
       }
        }
       
       
        if(filterData2.stops) {
          if(filterData2.stops =="0"){
            //console.log(getduration2(newData[0][0].Segments[0]))
          newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==1)
          
        }
        if(filterData2.stops =="1"){
          // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
          newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==2)
        
       }
       if(filterData2.stops =="2"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==3)
       
       }
       if(filterData2.stops =="3"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==4)
       
       }
        }
       
       
        if(filterData2.baggage) {
          if(filterData2.baggage =="0"){
            //console.log(checkbaggage(newData[0][0].Segments,filterData.baggage))
          newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
          
        }
        if(filterData2.baggage =="1"){
          // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
          newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
        
       }
       if(filterData2.baggage =="2"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
       
       }
       if(filterData2.baggage =="3"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
       
       }
        }
       
       
        if(filterData2.stopover) {
          if(filterData2.stopover =="0-4 hrs"){
            //console.log(getstopover(newData[0][0].Segments[1]))
          newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])<240)
        }
        if(filterData2.stopover =="4-8 hrs"){
          // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
        newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=240 && getstopover(r.Segments[1])<480)
       
       }
       if(filterData2.stopover =="8-12 hrs"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=480 && getstopover(r.Segments[1])<720)
       
       }
       if(filterData2.stopover =="12-16 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=720 && getstopover(r.Segments[1])<960)
       
       }
       if(filterData2.stopover =="16-20 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=960 && getstopover(r.Segments[1])<1200)
       
       }
       if(filterData2.stopover =="20-24 hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=1200 && getstopover(r.Segments[1])<1440)
       
       }
       if(filterData2.stopover =="24+ hrs"){
       // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
       newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=1440)
       
       }
       }
       }
       
       
       
         
       
         setsearchResponse({...saveresults.Response, Results:newData})
         
       }

    const handleSubmit =async (e) => {
        e.preventDefault();
        if(searchData.number_adults+searchData.number_child+searchData.number_infant>9){
          alert("Total passengers cannot be more than 9")
        }else{
        setstatus("searching");
        var segment=[]
        //console.log(airportdata);
        for(let i=0; i<airportdata.length; i++){
          const s=airportlist.filter(a=>a.city==airportdata[i].source)
          const d=airportlist.filter(a=>a.city==airportdata[i].dest)
          const temp={
            "Origin":s.length>0?s[0].airport:"",
            "Destination":d.length>0?d[0].airport:"",
            "FlightCabinClass":airportdata[i].cabin_class=="All"?1:airportdata[i].cabin_class=="Economy"?2:airportdata[i].cabin_class=="Premium Economy"?3:airportdata[i].cabin_class=="Business"?4:airportdata[i].cabin_class=="Premium Busines"?5:airportdata[i].cabin_class=="First"?6:0,
            "PreferredDepartureTime":getdate(airportdata[i].date,airportdata[i].departure_time),
            "PreferredArrivalTime":getdate(airportdata[i].date,airportdata[i].arrival_time)
          }
          segment.push(temp)
        }

        const finalsearchData={
          "TokenId":token,
          "AdultCount":searchData.number_adults,
          "ChildCount":searchData.number_child,
          "InfantCount":searchData.number_infant,
          "DirectFlight":searchData.stops==0?1:0,
          "OneStopFlight":searchData.stops==1?1:0,
          "JourneyType":searchData.type=="One-way" ? 1: searchData.type=="Return"?2: searchData.type=="Multi-stop"?3: searchData.type=="Special Return"?5:searchData.type=="Advanced Search"?4:0,
          "PreferredAirlines": null,
          "Sources": searchData.type=="Special Return"?["4","5"]:null,
          //"Sources": ["4","5"],
          "Segments":segment
        }

        console.log(finalsearchData)
        const sfResponse= await fetchflights(finalsearchData);
        
        if(sfResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          
            console.log(sfResponse.data)
            setsaveresults(sfResponse.data)
            setsearchResponse(sfResponse.data.Response)
            setstatus("completed")
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/home");
        }
      }
    }

    const prebook=()=>{
      if(resultpass.length==2 && resultpass[0] && resultpass[1]){
        setshowbook(true)
      }else{
        alert("Select flights for both sides")
      }
    }

    const farerule=async(result)=>{
      if(searchData.type=="Return" && searchResponse.Results.length>1){
        var temp=resultpass.length>0?[...resultpass]:[]
          if(result.ResultIndex.startsWith("OB")){    
                temp[0]=result
          }else if(result.ResultIndex.startsWith("IB")){
            if(temp.length==0){
              temp[0]=null              
              temp[1]=result
            } else{
              temp[1]=result
            } 
          }
        setresultpass(temp)
       
      }else{
      setresultpass(result)
      setshowbook(true)
      }
    }

    const showinbound=(value)=>{
      console.log(value)
       setinbound(true)
       setinboundindex(value)
      }
     
      const showoutbound=()=>{
       setinbound(false)
       setinboundindex(null)
      }

      const getTCToken=async()=>{
        //console.log(process.env)
        const data= await fetchTokenData();
        console.log(data.data)
        const temp=data.data.filter(t=>t.source=="Travclan")
        settoken(temp[0].token)
        const newDate=DateCalc(0)
        const saveddate=DateCalc2(temp[0].date, 0)
        //console.log(newDate)
        //console.log(saveddate)
        if(newDate!==saveddate){
            console.log("Fetching token")
            const newtokendata={
                // "merchant_id":process.env.REACT_APP_TC_MERCHANT_ID,
                // "user_id":process.env.REACT_APP_TC_USER_ID,
                // "api_key":process.env.REACT_APP_TC_API_KEY,
                "merchant_id":"jetovac8",
                "user_id":"c881dfca7",
                "api_key":"24a04715-8979-4beb-9309-182e63eed1fd",
      
              }
            //console.log(newtokendata)
            const data2 = await refreshTCToken(newtokendata);
            
            console.log(data2.data)
            settoken(data2.data.AccessToken)
            const newtokendata2={
              token:data2.data.AccessToken,
              date:new Date(),
              source:"Travclan"
            }
            //console.log(newtokendata2)
            const updatetokenResponse= await updateTokenData(temp[0]._id, newtokendata2);
            
            if(updatetokenResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                console.log("Token Data Updated")
            }
            else{
                alert("Unable to refresh currency data");
                
            }
        }else{
            console.log("New token will be fetched after 24 hours")
        }
        
       }

    //console.log(searchResponse && "Results" in searchResponse?searchResponse.Results:"Results not present in searchResponse")
    //console.log(saveresults)
    
    return (
      <div>
        {showbook?(
      <div>
      <Button
                    variant="contained"
                    color="primary"
                    onClick={e=>setshowbook(false)}
                    
                    className={classes.button}
                  >
                    Back
                  </Button>
      <TBOBook 
        result={resultpass}
        traceid={saveresults.Response.TraceId}
        searchData={searchData}
        token={token}
      />
      </div>
      ):(
        
        <Paper variant="outlined" className={classes.paper}>
        {/* <div align="right">
      <Button
              variant="outlined"
              color="secondary"
              className={classes.button3}
              href={"/flightview"}
              
            >
              {" "}
              View Booked Flights
            </Button>
      </div> */}
        <form >
        <FormGroup row className={classes.formgroup}>
                
        <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Adults (12+ years)"
                required
                variant="outlined"
                value={searchData.number_adults}
                onChange={(e) => setsearchData({...searchData, number_adults:e.target.value})}
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Child"># Child (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Child (2-12 years)"
                required
                variant="outlined"
                value={searchData.number_child}
                onChange={(e) => setsearchData({...searchData, number_child:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Infant"># Infant (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Infant (0-1 years)"
                required
                variant="outlined"
                value={searchData.number_infant}
                onChange={(e) => setsearchData({...searchData, number_infant:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
                
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                
                
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Type</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Journey Type"
                        required
                        variant="outlined"
                        value={searchData.type}
                        onChange={(e) => controlleg(e.target.value)}
                      >
                        <MenuItem value={"One-way"}>One-way</MenuItem>
                        <MenuItem value={"Return"}>Return</MenuItem>
                        {/* <MenuItem value={"Multi-stop"}>Multi-stop</MenuItem>
                        <MenuItem value={"Advanced Search"}>Advanced Search</MenuItem>
                        <MenuItem value={"Special Return"}>Special Return</MenuItem> */}
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Stops"
                        required
                        variant="outlined"
                        value={searchData.stops}
                        onChange={(e) => setsearchData({...searchData, stops:e.target.value})}
                      >
                        <MenuItem value={0}>0 </MenuItem>
                        <MenuItem value={1}>1 </MenuItem>
                        <MenuItem value={"Any"}>Any </MenuItem>
                        
                      </Select>
                    </FormControl>
                        
                    </FormGroup>
                    <hr></hr>
                    {airportdata.length>0 && airportdata.map(leg => {
            return(
            <div>
            <FormGroup row className={classes.formgroup}>
            <Typography className={classes.textField}>{"Leg "+(airportdata.indexOf(leg)+1)}</Typography>
            
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Source">From</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Source"
                required
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.source}
                onChange={(e) => sourcechange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Destination">To</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Destination"
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.dest}
                onChange={(e) => destchange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              type="date"
              name={airportdata.indexOf(leg)}
              inputProps={{ min: airportdata[airportdata.indexOf(leg)-1] && "date" in airportdata[airportdata.indexOf(leg)-1]?airportdata[airportdata.indexOf(leg)-1].date:fupfinalDate2 }}
              label="Date"
              required
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => datechange(e, e.target.name, leg.id)
              }
            />
            
                    </FormGroup>
                    <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Cabin Class</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Cabin Class"
                        required
                        variant="outlined"
                        value={leg.cabin_class}
                        onChange={(e) => classchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        <MenuItem value={"Economy"}>Economy </MenuItem>
                        <MenuItem value={"Premium Economy"}>Premium Economy </MenuItem>
                        <MenuItem value={"Business"}>Business </MenuItem>
                        <MenuItem value={"Premium Business"}>Premium Business </MenuItem>
                        <MenuItem value={"First"}>First </MenuItem>
                      </Select>
                    </FormControl>
                    {/* <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Departure Time"
                        required
                        variant="outlined"
                        value={leg.departure_time}
                        onChange={(e) => departurechange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Ariival Time"
                        required
                        variant="outlined"
                        value={leg.arrival_time}
                        onChange={(e) => arrivalchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl> */}
                    
          </FormGroup>
    
           
            </div>)
          })}
           <FormGroup row className={classes.formgroup}>
           {/* {control?(<div>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addsp}
            >
              {" "}
              + Leg
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removesp}
              
            >
              {" "}
              - Leg
            </Button>
           </div>):("")} */}
             
                <Button variant="contained" color="primary" onClick={TCFlightSearch} className={classes.button}>Search</Button>
                
            </FormGroup>
            </form>
            <br></br>
            <hr></hr>
            <hr></hr>
            {status === "Normal" ? (
              ""
            ) : (
              <div>
                {status == "searching" ? (
                  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
            <LinearProgress color="secondary" />
            <LinearProgress color="primary" />
            <LinearProgress color="inherit" />
          </Stack>
                ) : (
                  <div>
                {tcresultpass && tcresultpass.length>0?(
                  <Typography variant="h4" className={classes.red}>Selected Flights</Typography>
                ):("")}  
                {tcresultpass && tcresultpass.length>0?(
                  <div>
                  {tcresultpass.map(result=>
                    <div>
                   
                   <Typography variant="h6" className={classes.black}>Result {tcresultpass.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                                    <br></br>
                                  
                                    {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                                  <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result.iR} || Remark: {result.ar} 
                                  </Typography>
                                  <FormGroup row className={classes.formgroup}>
                    {tcresultpass.indexOf(result)+1==tcresultpass.length?(
                                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCprebook()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button> */}
                ):("")}            
                                 
                                 </FormGroup>
                                  
                                 <hr></hr>
                                  
                                  </div>
                  )}
                 
                  </div>
                ):("")}
                {searchResponse && "traceId" in searchResponse?(<div>
                  {/* <FormGroup row className={classes.formgroup}>
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Airline</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="airline"
                        variant="outlined"
                        value={filterData.airline}
                        onChange={(e) => setfilterData({...filterData, airline:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                       {airlinelist2.map((airline)=>
                       <MenuItem value={airline}>{airline}</MenuItem>
                        )}
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData.departure}
                        onChange={(e) => setfilterData({...filterData, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData.arrival}
                        onChange={(e) => setfilterData({...filterData, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Multi-Airline</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="multi"
               
                        variant="outlined"
                        value={filterData.multi}
                        onChange={(e) => setfilterData({...filterData, multi:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        
                      </Select>
                    </FormControl>
                  </FormGroup> */}
                  
                
                  {/* {searchData && "type" in searchData && searchData.type == "Return" && searchResponse && "results" in searchResponse?(
                    <div>
                    <hr></hr>
                    <h3>For return flights:</h3>
                    <FormGroup row className={classes.formgroup}>
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData2.departure}
                        onChange={(e) => setfilterData2({...filterData2, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData2.arrival}
                        onChange={(e) => setfilterData2({...filterData2, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData2.duration}
                        onChange={(e) => setfilterData2({...filterData2, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}> 
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData2.stops}
                        onChange={(e) => setfilterData2({...filterData2, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData2.baggage}
                        onChange={(e) => setfilterData2({...filterData2, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData2.stopover}
                        onChange={(e) => setfilterData2({...filterData2, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  </div>
                  ):("")}
                
                  <FormGroup row className={classes.formgroup}>    
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={tcfilterresults}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
                   </FormGroup> */}
                 
              
              {"results" in searchResponse && "inboundFlights" in searchResponse.results && searchResponse.results.outboundFlights.length>0&& searchResponse.results.inboundFlights.length>0?(
                <div>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      centered
    >
      <Tab label="Segment 1" {...a11yProps(0)} />
      <Tab label="Segment 2" {...a11yProps(1)} />
     </Tabs>
  </Box>
  <TabPanel value={value} index={0}>
  {searchResponse.results.outboundFlights.map(result=>
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.outboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                     {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "OB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button> */}
                 
                  
                  </FormGroup>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={1}>
  {searchResponse.results.inboundFlights.map(result=>
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.inboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                     {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "IB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button> */}
                 
                  
                  </FormGroup>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
              </div>
              ):
              ( 
              <div>
           
 
              {searchResponse.results.outboundFlights.map(result=>
              <div>
               
              {"inboundFlights" in result?(
                <div>
   <Typography variant="h6" className={classes.black}>Result Set {searchResponse.results.outboundFlights.indexOf(result)+1} </Typography>
       
  
  {!inbound && result.outboundFlight.map(result2=>
                  
                <div>
               
                   <Typography variant="h6" className={classes.black}> (LCC: {result2.iL?"True":"False"} || Fare Type: {result2.pFC}) || Price: {result2.fF}</Typography>
                                    <br></br>
                                  
                                 
                                   
                                   
                                      <Typography variant="h6" className={classes.red}>
                                    {"GroundTime:"+result2.gT+ "|| Stop Point:"+result2.sP+" || Stop Duration: "+Math.floor(result2.sD/60)+" hrs"+result2.sD%60+" mins"+" || Seats Left: "+result2.nOSA}
                                  </Typography>
                                  <br></br>
                                      <Typography variant="h6" className={classes.orange}>
                                    Airline: {result2.al.alN} ({result2.al.alC}-{result2.al.fN}{result2.al.fC}) || Class: {getclass(result2.cC)} || Baggage: {result2.bg}  || CabinBaggage: {result2.cBg} || Flight Duration: {Math.floor(result2.dr/60)+" hrs"+result2.dr%60+" mins"}
                                  </Typography>
                                  
                                  <Typography variant="h6" className={classes.blue}>Origin-Destination: {result2.or.cN} ({result2.or.aC}) - Terminal {result2.or.tr} --------------------- {"> "+result2.ds.cN} ({result2.ds.aC}) - Terminal {result2.ds.tr} </Typography> 
                                  <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(result2.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(result2.ds.aT).toLocaleString("en-IN")}</Typography>
                                  <br></br>
                                 
                                  
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result2.iR} || Remark: {result2.ar} 
                                  </Typography>
                                 
                                  
                              
                                  
                                  </div>
              )}
              {inbound?(""):(
  <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showinbound(searchResponse.results.outboundFlights.indexOf(result)+1)}
                    
                    className={classes.button}
                  >
                    Show Inbound
                  </Button>
   )}

   
   {inbound && inboundindex && searchResponse.results.outboundFlights.indexOf(result)+1==inboundindex && result.inboundFlights.map(result2=>
                <div>
                <Typography variant="h6" className={classes.black}>Inbound Flight</Typography>
                   <Typography variant="h6" className={classes.black}> Inbound result: {result.inboundFlights.indexOf(result2)} (LCC: {result2[0].iL?"True":"False"} || Fare Type: {result2[0].pFC}) || Price: {result2[0].fF}</Typography>
                                    <br></br>
                                  
                                 {result2[0].sg.map(segment => 
                                 <div>
                                   
                                   
                                      <Typography variant="h6" className={classes.red}>
                                    {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                                  </Typography>
                                  <br></br>
                                      <Typography variant="h6" className={classes.orange}>
                                    Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                                  </Typography>
                                  
                                  <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                                  <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                                  <br></br>
                                  </div>)}
                                  <Typography variant="h6" className={classes.red}>Price: INR {result2[0].fF} </Typography>
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result2[0].iR} || Remark: {result2[0].ar} 
                                  </Typography>

                                  <FormGroup row className={classes.formgroup}>
                                  {/* <Button
                                   variant="contained"
                                   color="primary"
                                   onClick={()=>TCfarerule2(result,result2[0])}
                                   
                                   className={classes.button}
                                 >
                                   Select
                                 </Button> */}
                                 <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showoutbound()}
                    
                    className={classes.button}
                  >
                    Show Outbound
                  </Button> 
                                 
                                 </FormGroup>
                                  
                                 <hr></hr>
                                  
                                  </div>
              )}
              {/* {inbound?(
 <FormGroup row className={classes.formgroup}>
              <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showoutbound()}
                    
                    className={classes.button}
                  >
                    Show Outbound
                  </Button>  
                 
                </FormGroup>
               ):("")} */}

              
                </div>
              ):(
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.outboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                  {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "OB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button> */}
                 
                  
                  </FormGroup>
                   
                  <hr></hr>
                   
                   </div>)}
                   </div>)}
   
              </div>
              )}
           
                </div>):(<div>
                  <h2>Waiting for response</h2>
                </div>)}

                {/* </div>
                  <div> */}
                {/* {resultpass && resultpass.length>0?(
                  <Typography variant="h4" className={classes.red}>Selected Flights</Typography>
                ):("")}   */}
                {/* {resultpass && resultpass.length>0?(
                  <div>
                  {resultpass.map(result=>
                  <div>
                               <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[resultpass.indexOf(result)].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                  
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <hr></hr>
                   <hr></hr>
                  </div>
                  )}
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>prebook()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button>
                  </div>
                ):("")} */}
                {/* {searchResponse && "ResponseStatus" in searchResponse?(<div>
                  <FormGroup row className={classes.formgroup}>
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Airline</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="airline"
                        variant="outlined"
                        value={filterData.airline}
                        onChange={(e) => setfilterData({...filterData, airline:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                       {airlinelist2.map((airline)=>
                       <MenuItem value={airline}>{airline}</MenuItem>
                        )}
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData.departure}
                        onChange={(e) => setfilterData({...filterData, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData.arrival}
                        onChange={(e) => setfilterData({...filterData, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Multi-Airline</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="multi"
               
                        variant="outlined"
                        value={filterData.multi}
                        onChange={(e) => setfilterData({...filterData, multi:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        
                      </Select>
                    </FormControl>
                  </FormGroup>
                  {searchData && "type" in searchData && searchData.type == "Multi-stop"?(""):(
                    <FormGroup row className={classes.formgroup}> 
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData.duration}
                        onChange={(e) => setfilterData({...filterData, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData.stops}
                        onChange={(e) => setfilterData({...filterData, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData.baggage}
                        onChange={(e) => setfilterData({...filterData, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData.stopover}
                        onChange={(e) => setfilterData({...filterData, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  )}
                  {searchData && "type" in searchData && searchData.type == "Return" && searchResponse && "Results" in searchResponse && searchResponse.Results.length==1?(
                    <div>
                    <hr></hr>
                    <h3>For return flights:</h3>
                    <FormGroup row className={classes.formgroup}>
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData2.departure}
                        onChange={(e) => setfilterData2({...filterData2, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData2.arrival}
                        onChange={(e) => setfilterData2({...filterData2, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData2.duration}
                        onChange={(e) => setfilterData2({...filterData2, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}> 
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData2.stops}
                        onChange={(e) => setfilterData2({...filterData2, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData2.baggage}
                        onChange={(e) => setfilterData2({...filterData2, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData2.stopover}
                        onChange={(e) => setfilterData2({...filterData2, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  </div>
                  ):("")}
                  <FormGroup row className={classes.formgroup}>    
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={filterresults}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
                   </FormGroup>
                  { searchResponse.ResponseStatus==1 ?(<div>
              
              {"Results" in searchResponse && searchResponse.Results.length==1?(<div>
                {searchResponse.Results[0].map(result => <div>
                  <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[0].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {"FareBreakdown" in result && result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                   
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  <hr></hr>
                </div>)}
              </div>):
              searchResponse.Results.length>1?(<div>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      centered
    >
      <Tab label="Segment 1" {...a11yProps(0)} />
      {searchResponse.Results.length> 1 ?
      <Tab label="Segment 2" {...a11yProps(1)} />:""}
      {searchResponse.Results.length> 2 ?
      <Tab label="Segment 3" {...a11yProps(2)} />:""}
      {searchResponse.Results.length> 3 ?
      <Tab label="Segment 4" {...a11yProps(3)} />:""}
      {searchResponse.Results.length> 4 ?
      <Tab label="Segment 5" {...a11yProps(4)} />:""}
      
    </Tabs>
  </Box>
  <TabPanel value={value} index={0}>
  {searchResponse.Results[0].map(result=><div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[0].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     {"FareBreakdown" in result ?(<Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>):(<div></div>)}
                     
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage}  || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                  
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {"FareBreakdown" in result?getprice(result.Fare):""} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={1}>
  {searchResponse.Results.length> 1 && searchResponse.Results[1].map(result=><div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[1].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     {"FareBreakdown" in result ?(
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                     ):("")}
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} {getduration(segment)}
                   </Typography>
                  
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {"FareBreakdown" in result?getprice(result.Fare):""} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={2}>
  {searchResponse.Results.length> 2 && searchResponse.Results[2].map(result=><div>
                   
                   {result.Segments.map(segment => <div>
                     <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[2].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):("")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} || Cancellation Charges: {"PenaltyCharges" in result && "CancellationCharge" in result.PenaltyCharges ?result.PenaltyCharges.CancellationCharge:""}</Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                     <hr></hr>
                   </div>)}
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={3}>
  {searchResponse.Results.length> 3 && searchResponse.Results[3].map(result=><div>
                   
                   {result.Segments.map(segment => <div>
                     <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[3].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):("")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} || Cancellation Charges: {"PenaltyCharges" in result && "CancellationCharge" in result.PenaltyCharges ?result.PenaltyCharges.CancellationCharge:""}</Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                     <hr></hr>
                   </div>)}
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={4}>
  {searchResponse.Results.length> 4 && searchResponse.Results[4].map(result=><div>
                   
                   {result.Segments.map(segment => <div>
                     <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[4].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):("")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} || Cancellation Charges: {"PenaltyCharges" in result && "CancellationCharge" in result.PenaltyCharges ?result.PenaltyCharges.CancellationCharge:""}</Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                     <hr></hr>
                   </div>)}
                   
                   </div>)}
  </TabPanel>
              </div>):(<div></div>)}
            </div>):(<div>
              { searchResponse.ResponseStatus==3 || searchResponse.ResponseStatus==2?(<div>
                {searchResponse.Error.ErrorMessage}
              </div>):(<div></div>)}
            </div>)}
                </div>):(<div>
                  <h2>Waiting for response</h2>
                </div>)} */}

                </div>
                )} 
                </div>)}

        </Paper>
      )}
        </div>
    )
}

export default TBOSearch;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}